import { render, staticRenderFns } from "./news-info.vue?vue&type=template&id=59e2cc60&scoped=true"
import script from "./news-info.vue?vue&type=script&lang=js"
export * from "./news-info.vue?vue&type=script&lang=js"
import style0 from "./news-info.vue?vue&type=style&index=0&id=59e2cc60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e2cc60",
  null
  
)

export default component.exports